
const language_app = {
    app: {
        'zh-tw': "App設定",
        en: "",
        children: {
            // DataView: {
            //     'zh-tw': "統計分析",
            //     en: "",
            //     children: {
            //     }
            // },
            News:{
                'zh-tw': "最新消息",
                en: "",
                children: {
                }
            },
            carousels:{
                'zh-tw': "輪播圖管理",
                en: "",
                children: {
                    primary:{
                        'zh-tw': "主要輪播圖",
                        en: "",
                        children: {
                        }
                    },
                }
            },
            Chatbot:{
                'zh-tw': "Q&A機器人",
                en: "",
                children: {
                }
            },
            RWDFunction:{
                'zh-tw': "連結管理",
                en: "",
                children: {
                }
            },
        }
    }
}


export {
    language_app
}